import { Badge } from 'antd';
// eslint-disable-next-line no-unused-vars
import dayjs, { Dayjs } from 'dayjs';

import * as XLSX from 'xlsx';

// Function to convert time string to Date object
function parseTime(timeString) {
  const [hours, minutes] = timeString.split(':').map(Number);
  const date = new Date();
  date.setHours(hours, minutes, 0, 0); // Ignore seconds
  return date;
}
// TODO: Deprecated
// Function to check if time is within 10 minutes range
function isWithin10Minutes(time1, time2) {
  const diffMilliseconds = Math.abs(time1 - time2);
  const diffMinutes = diffMilliseconds / (1000 * 60); // Convert milliseconds to minutes
  return diffMinutes <= 10;
}
/**
 * Check if two dates are within 10 minutes of each other.
 * @param {Dayjs} dateTime1 - A Date object or timestamp (milliseconds)
 * @param {Dayjs} dateTime2 - A Date object or timestamp (milliseconds)
 * @returns {boolean} True if the difference is ≤ 10 minutes
 */
function isWithin10Minutes2(dateTime1, dateTime2) {
  const diffMinutes = Math.abs(dateTime1.diff(dateTime2, 'minute', true));
  return diffMinutes <= 10;
}

export const cellBadge = (attendanceRecord, assignedShift) => {
  // No attendance record for the day.
  if (!attendanceRecord) return <Badge color="red" />;
  if (!assignedShift) return 'N/A';
  return (
    <Badge color={checkAttendanceStatus(attendanceRecord, assignedShift)} />
  );
};

export function checkAttendanceStatus(attendanceRecord, assignedShift) {
  if (!attendanceRecord) return <Badge color="red" />;
  let checkInTime = attendanceRecord.checkInTime;
  let checkInDate = attendanceRecord.checkInDate;
  let checkOutDate = attendanceRecord.checkOutDate;
  let checkOutTime = attendanceRecord.checkOutTime;
  // Did not check in or out.
  if (!checkInTime || !checkOutTime) return 'orange';

  const checkInDateTime = dayjs(
    `${checkInDate} ${checkInTime}`,
    'YYYY-MM-DD hh:mm:ss',
  );

  const checkOutDateTime = dayjs(
    `${checkOutDate} ${checkOutTime}`,
    'YYYY-MM-DD hh:mm:ss',
  );

  if (assignedShift) {
    const shiftStartingTime = assignedShift.startingTime;
    const shiftEndingTime = assignedShift.endingTime;

    const shiftStartDateTime = dayjs(
      `${checkInDate} ${shiftStartingTime}`,
      'YYYY-MM-DD hh:mm:ss',
    );

    const shiftEndDateTime = dayjs(
      `${checkOutDate} ${shiftEndingTime}`,
      'YYYY-MM-DD hh:mm:ss',
    );

    if (
      isWithin10Minutes2(checkInDateTime, shiftStartDateTime) &&
      isWithin10Minutes2(checkOutDateTime, shiftEndDateTime)
    )
      return 'green';
    else if (
      checkInDateTime.isAfter(shiftStartDateTime) ||
      checkOutDateTime.isBefore(shiftEndDateTime)
    )
      return 'yellow';
    else if (
      checkInDateTime.isBefore(shiftStartDateTime) ||
      checkOutDateTime.isAfter(shiftEndDateTime)
    )
      return 'geekblue';
  }
}

export const cellText = (attendanceRecord, assignedShift) => {
  // No attendance record for the day.
  if (!attendanceRecord) return 'No attendance record';

  let checkInTime = attendanceRecord.checkInTime;
  let checkOutTime = attendanceRecord.checkOutTime;

  // Did not check in or out.
  if (!checkInTime || !checkOutTime) return 'Did not check in or out';

  if (assignedShift) {
    checkInTime = parseTime(checkInTime);
    checkOutTime = parseTime(checkOutTime);

    const shiftStartingTime = parseTime(assignedShift.startingTime);
    const shiftEndingTime = parseTime(assignedShift.endingTime);

    if (
      isWithin10Minutes(checkInTime, shiftStartingTime) &&
      isWithin10Minutes(checkOutTime, shiftEndingTime)
    )
      return 'Normal Hours';
    else if (checkInTime > shiftStartingTime || checkOutTime < shiftEndingTime)
      return 'Missing Hours';
    else if (checkInTime < shiftStartingTime || checkOutTime > shiftEndingTime)
      return 'Extra Hours';
  }

  return 'N/A';
};

export const exportToExcel = (dataSource, columns) => {
  // Convert dataSource to an array of objects with keys corresponding to column titles
  const dataForSheet = dataSource.map(item => {
    const rowData = {};
    columns.forEach(col => {
      console.log('col: ', col);
      console.log('item: ', item);

      console.log('col.dataIndex', !!col.dataIndex, col.dataIndex);

      rowData['Usher ID'] = item['usherID'];

      rowData['Full Name'] = item['usherName'];

      rowData['Assigned Shift'] =
        item['assignedShift']['startingTime'] +
        ' - ' +
        item['assignedShift']['endingTime'];

      if (col.dataIndex) {
        const record = item.attendanceRecords.find(
          obj => Object.keys(obj)[0] === col.dataIndex,
        );
        rowData[col.title] = cellText(record[col.title], item.assignedShift);
      }
    });
    return rowData;
  });

  // Create a worksheet
  const ws = XLSX.utils.json_to_sheet(dataForSheet);

  // Create a workbook and add the worksheet
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

  // Export the workbook as an Excel file
  XLSX.writeFile(wb, 'table_data.xlsx');
};
